<template>
    <div class="np-form-field-checkbox">
        <input
            class="np-form-field-checkbox__input" type="checkbox"
            :id="field"
            @change="updateInput"
            :checked="value"
        >
        <span class="np-form-field-checkbox__custom-checkbox"></span>
        <label class="np-form-field-checkbox__label"
            :for="field"
        >
            {{ text }}
        </label>
    </div>
</template>

<script>

export default {
    name: 'new-payment-form-field-checkbox',
    props: {
        field: {
            type: String
        },
        value: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: ''
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    methods: {
        updateInput(e) {
            this.$emit('change', e.target.checked);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mixins-and-vars';
$parent: '.np-form-field-checkbox';

#{$parent} {
    position: relative;
    display: flex;
    align-items: center;
    margin: 20px 0 15px;

    &__input {
        display: none;
        
        &:checked + span:before {
            display: block;
        }
    }

    &__label {
        padding-left: 30px;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        user-select: none;
        cursor: pointer;
        z-index: 1;
    }

    &__custom-checkbox {
        position: absolute;
        display: block;
        width: 20px;
        height: 20px;
        top: 0;
        border: 3px solid $color-brand;
        border-radius: 3px;
        user-select: none;
        cursor: pointer;
        z-index: 0;

        &:after {
            display: none;
        }

        &:before {
            display: none;
            position: absolute;
            content: '';
            width: 12px;
            height: 9px;
            left: 1px;
            top: 50%;
            transform: translateY(-50%);
            background-color: transparent !important;
            background-image: url("data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.56578 4.79446L2.71435 2.97875L0.714355 5.02161L4.57721 8.80303L11.2901 2.15875L9.2815 0.127319L4.56578 4.79446Z' fill='%2300ABAA'/%3E%3C/svg%3E%0A");
        }
    }
}
</style>